import { handleActions } from 'redux-actions';
import {
  updateModule,
  purgeAllModules,
  fetchModuleDataSuccess,
  fetchModuleConfig,
  fetchModuleConfigSuccess,
  fetchModuleConfigError,
  saveModuleConfig,
  saveModuleConfigSuccess,
  saveModuleConfigError,
} from '../actions/modules';
import { removeModuleSuccess } from '../actions/layout';
import omit from 'lodash/omit';

const defaultState = {};

export default handleActions<any, any>(
  {
    [fetchModuleDataSuccess.toString()]: (state, action) => ({
      ...state,
      [action.payload.id]: omit(action.payload, ['entities']),
    }),
    [removeModuleSuccess.toString()]: (state, action) => {
      const { [action.payload.moduleId]: remove, ...rest } = state;
      return rest;
    },
    [updateModule.toString()]: (state, action) => ({
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        moduleData: {
          ...state[action.payload.id].moduleData,
          ...action.payload.moduleData,
        },
        moduleMeta: {
          ...state[action.payload.id].moduleMeta,
          ...action.payload.moduleMeta,
        },
      },
    }),
    [fetchModuleConfig.toString()]: (state, action) => ({
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        moduleMeta: {
          ...(state[action.payload.id]?.moduleMeta || {}),
          isFetchingConfig: true,
          errorDescription: undefined,
        },
      },
    }),
    [fetchModuleConfigSuccess.toString()]: (state, action) => ({
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        moduleConfig: action.payload.config,
        moduleMeta: {
          ...(state[action.payload.id]?.moduleMeta || {}),
          isFetchingConfig: false,
        },
      },
    }),
    [fetchModuleConfigError.toString()]: (state, action) => ({
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        moduleMeta: {
          ...(state[action.payload.id]?.moduleMeta || {}),
          isFetchingConfig: false,
          errorDescription: action.payload.errorDescription,
        },
      },
    }),
    [saveModuleConfig.toString()]: (state, action) => ({
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        moduleMeta: {
          ...(state[action.payload.id]?.moduleMeta || {}),
          isSavingConfig: true,
          errorDescription: undefined,
        },
      },
    }),
    [saveModuleConfigSuccess.toString()]: (state, action) => ({
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        moduleConfig: action.payload.config,
        moduleMeta: {
          ...(state[action.payload.id]?.moduleMeta || {}),
          isSavingConfig: false,
        },
      },
    }),
    [saveModuleConfigError.toString()]: (state, action) => ({
      ...state,
      [action.payload.id]: {
        ...state[action.payload.id],
        moduleMeta: {
          ...(state[action.payload.id]?.moduleMeta || {}),
          isSavingConfig: false,
          errorDescription: action.payload.errorDescription,
        },
      },
    }),
    [purgeAllModules.toString()]: () => ({}),
  },
  defaultState
);
